"use strict";
import { __exports as c } from "./index.es340.js";
var p;
function P() {
  return p ? c : (p = 1, (function(f) {
    Object.defineProperty(f, "__esModule", {
      value: !0
    });
    function A(r, t) {
      for (var n in t) Object.defineProperty(r, n, {
        enumerable: !0,
        get: t[n]
      });
    }
    A(f, {
      PARAMETER_PATTERN: function() {
        return a;
      },
      getDynamicParam: function() {
        return v;
      },
      parseMatchedParameter: function() {
        return i;
      },
      parseParameter: function() {
        return s;
      }
    });
    function v(r, t, n, R, o) {
      let e = r[t];
      if (o && o.has(t) ? e = o.get(t) : Array.isArray(e) ? e = e.map((u) => encodeURIComponent(u)) : typeof e == "string" && (e = encodeURIComponent(e)), !e) {
        const u = n === "c", l = n === "oc";
        if (u || l)
          return l ? {
            param: t,
            value: null,
            type: n,
            treeSegment: [
              t,
              "",
              n
            ]
          } : (e = R.split("/").slice(1).flatMap((E) => {
            const _ = s(E);
            var h;
            return (h = r[_.key]) != null ? h : _.key;
          }), {
            param: t,
            value: e,
            type: n,
            // This value always has to be a string.
            treeSegment: [
              t,
              e.join("/"),
              n
            ]
          });
      }
      return {
        param: t,
        // The value that is passed to user code.
        value: e,
        // The value that is rendered in the router tree.
        treeSegment: [
          t,
          Array.isArray(e) ? e.join("/") : e,
          n
        ],
        type: n
      };
    }
    const a = /^([^[]*)\[((?:\[[^\]]*\])|[^\]]+)\](.*)$/;
    function s(r) {
      const t = r.match(a);
      return i(t ? t[2] : r);
    }
    function i(r) {
      const t = r.startsWith("[") && r.endsWith("]");
      t && (r = r.slice(1, -1));
      const n = r.startsWith("...");
      return n && (r = r.slice(3)), {
        key: r,
        repeat: n,
        optional: t
      };
    }
  })(c), c);
}
export {
  P as __require
};
//# sourceMappingURL=index.es315.js.map
